import React from "react";
import { useNavigate } from "react-router-dom";
import { BiPlusMedical } from "react-icons/bi";
import { GrFacebookOption, GrLinkedinOption } from "react-icons/gr";
import { AiOutlineInstagram } from "react-icons/ai";
import { useState } from "react";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { fetchPublicFaculty } from "../lib/api";

const table2 = [
  {
    fullName: "Ms. Parul Rayappan",
    academicQualification: "M.A.",
    professionalQualification: "B. Ed., B. P.Ed.,",
    post: "Principal",
  },
  {
    fullName: "Ms. Pinky Shah",
    academicQualification: "B.Com",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Kanchan Kharate",
    academicQualification: "B. A.",
    professionalQualification: "B. Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Sunita B. Rao",
    academicQualification: "B. A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Bhavesh A. Prajapati",
    academicQualification: "M.A., Diploma in Music",
    professionalQualification: "B.P. Ed., Diploma in Yoga",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Nayna J. Rathod",
    academicQualification: "B.A., PGDCA",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Parulben J. Raj",
    academicQualification: "M.Com., IT & E. Technology",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Nitesh S. Bhatiya",
    academicQualification: "M.A.",
    professionalQualification: "B.P. Ed., Diploma in Yoga",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Rajubhai V. Macwan",
    academicQualification: "B.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Rikesh M. Shelat",
    academicQualification: "M.Com., M.D.C.A., TFAP, DBM",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Jayati Mukherjee",
    academicQualification: "B.A., B.A.(Music)",
    professionalQualification: "Diploma in Fine Arts",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Sneha Sharma",
    academicQualification: "H.S.C., Dip. In Electrical Eng., PGDCA",
    professionalQualification: "",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Selvin M. Vaghela",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Bhavini P. Patel",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed., B.P.Ed",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Sweta P. Macwan",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Shilpa B. Soni",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Paresh K. Macwan",
    academicQualification: "B.P.A.",
    professionalQualification: "Sangeet Visharad, Dip. In Music (Vocal)",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Rashmi M. Chauhan",
    academicQualification: "B.A.",
    professionalQualification: "P.T.C.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Chiteralakha Mukherjee",
    academicQualification: "H.S.C.",
    professionalQualification: "Montessori",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Parita V. Solanki",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Purvikaben S. Prajapati",
    academicQualification: "B.A.",
    professionalQualification: "Montessori",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Priyank S. Chauhan",
    academicQualification: "M.A.",
    professionalQualification: "M.Ed., 5th DAN Black belt",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Shreyashi K. Mishra",
    academicQualification: "M.Sc.",
    professionalQualification: "M. Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Parita R. Suthar",
    academicQualification: "M.A.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Milan S. Pansuriya",
    academicQualification: "M.Sc.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Bhumi K. Ramani",
    academicQualification: "M.Sc.",
    professionalQualification: "B.Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Prakash G. Rohit",
    academicQualification: "M.A.",
    professionalQualification: "M. Lib., B.Ed.",
    post: "Librarian",
  },
  {
    fullName: "Ms. Megha R. Vaghela",
    academicQualification: "M.A.",
    professionalQualification: "",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Rinku S. Vaghela",
    academicQualification: "M.Com.",
    professionalQualification: "B. Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Ashwinkumar M. Pal",
    academicQualification: "M. Sc.",
    professionalQualification: "B. Ed.",
    post: "Asst.Teacher",
  },
  {
    fullName: "Ms. Keyuriben A. Pandya",
    academicQualification: "Dip. In FineArts",
    professionalQualification: "",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Hardik H. Brahmbhatt",
    academicQualification: "Dip. In FineArts, Multimedia",
    professionalQualification: "",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Nirbhay S. Jithara",
    academicQualification: "M. Sc.",
    professionalQualification: "",
    post: "Asst.Teacher",
  },
  {
    fullName: "Dr. Suresh N. Zala",
    academicQualification: "M.A., Ph. D.",
    professionalQualification: "B. Ed., PTC,",
    post: "Asst.Teacher",
  },
  {
    fullName: "Mr. Upendrasingh Raj",
    academicQualification: "B.Com",
    professionalQualification: "",
    post: "Office Asst.",
  },
  {
    fullName: "Ms. Tanvi U. Patel",
    academicQualification: "B.Com",
    professionalQualification: "",
    post: "Office Asst.",
  },
];

const tableData = [
  {
    fullName: "Full Name",
    education: "Education",
    student: "Student",
  },
  {
    fullName: "Full Name",
    education: "Education",
    student: "Student",
  },
  {
    fullName: "Full Name",
    education: "Education",
    student: "Student",
  },
  {
    fullName: "Full Name",
    education: "Education",
    student: "Student",
  },
  {
    fullName: "Full Name",
    education: "Education",
    student: "Student",
  },
];

const table = (table) => {
  return (
    <table
      class="table table-bordered text-white my-5"
      style={{ borderColor: "#5289BF" }}
    >
      <thead style={{ position: "sticky", top: "0" }}>
        <tr>
          <th scope="col" class="text-warning fs-5 text-nowrap">
            Teacher Name
          </th>
          <th scope="col" class="text-warning fs-5 text-nowrap">
            Academic Qualification
          </th>
          <th scope="col" class="text-warning fs-5 text-nowrap">
            Professional Qualification
          </th>
          <th scope="col" class="text-warning fs-5 text-nowrap">
            Post
          </th>
        </tr>
      </thead>
      <tbody>
        {table.map((el) => {
          return (
            <tr>
              <td>{el.fullName}</td>
              <td>{el.academicQualification}</td>
              <td>{el.professionalQualification}</td>
              <td>{el.post}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};


const principal = [
  "Mahatma Gandhi rightly said “The best way to find yourself is to lose yourself in the service of humankind.”",
  "Thinking in the same line I would indeed say that educating others is the best service to the society.",
  "",
  "I consider myself fortunate enough to have been entrusted with the responsibility of being a principal and an integral part of an educational institute where we are committed to nurturing young minds, fostering creativity, and instilling values that prepare our students to excel in an ever-changing world.",
  "",
  "I believe in upholding high standards with an absolute commitment to strive to understand and improve the educational process, using team strategies, while fully centering on student achievement.",
  "",
  "Our teachers are highly dedicated and put every child at the heart of everything they do.",
  "Our staff are deeply passionate about providing high-quality education, both in and outside the classroom, to ensure our students have the best possible chances of success both while at school and in the future.",
  "",
  "Our extracurricular activities provide opportunities for students to develop and flourish in sports, arts, dance, music and academia, where they can develop key life skills including confidence, teamwork and leadership.",
  "",
  "I invite parents and guardians to actively engage in their child’s education journey, partnering with us to ensure the best possible outcomes for our students.",
  "Your support and involvement play a crucial role in our shared mission of nurturing lifelong learners and responsible global citizens.",
  "",
  "I look forward to the adventures and achievements that await us in the coming year.",
  "Wishing all our students a happy and successful journey of learning!",
  "",
  "Ms. Parul Rayappan",
  "Principal",
  "Shristi English Medium School,",
  "Lambhvel, Anand"
];

export const Facilities = () => {
  const navigate = useNavigate();
  const [icon, setIcon] = useState(false);
  const [category, setCategory] = useState("Category1");
  const [facultyData, setFacultyData] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1500 });
  });

  useEffect(() => {
    fetchPublicFaculty(true)
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : [];
        if (rows.length > 0) {
          setFacultyData(
            rows.map((f) => ({
              fullName: f.name,
              academicQualification: f.academicQualification || "",
              professionalQualification: f.professionalQualification || "",
              post: f.post,
            }))
          );
        }
      })
      .catch(() => {});
  }, []);

  const ReaadMore = (pera) =>{
    // console.log(children);
    const [isReadMore, setIsReadMore] =useState(true)
    return(
        <>
        <p class='text'>
            {isReadMore ? pera.map((el,i)=> { 
                    if(i < 4){
                        return (
                            <>
                            {el} 
                            <br />
                            </>
                        )
                    }
            
            }): pera.map((el)=> <>{el} <br/>  </>)}
        </p>
        <div class='text-center' onClick={()=>setIsReadMore(!isReadMore)}>

        <button class='btn m-auto p-0 m-0' >{isReadMore ?<i class="bi bi-chevron-compact-down fs-1"></i> : <i class="bi bi-chevron-compact-up fs-1"></i>}</button>
        </div>
        </>
    )
}
  return (
    <div>
      <div style={{ background: "linear-gradient( white 50%, #215395 0) " }}>
        <div
          data-aos="zoom-in-up"
          class="d-grid align-items-center justify-content-center p-5"
          style={{
            backgroundImage: `url(${require("../images/about/top.png")})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div>
            <p class="display-3 fw-bold">Faculty</p>
            <p class="fw-semibold">
              {" "}
              <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
                Home
              </span>{" "}
              <span>|</span>{" "}
              <span
                onClick={() => navigate("/faculty")}
                style={{ cursor: "pointer" }}
              >
                Faculty
              </span>{" "}
            </p>
          </div>
        </div>

        <div
          class="col-11 m-auto"
          style={{ background: "linear-gradient( white 10%, #EFF6FF 0) " }}
        >
          <div class="row">
            <div class="col-lg-7 col-12 text-start ">
              <br />
              <br />
              <div class="col-11 m-auto">
                <p class="display-3 fw-bold mt-5" data-aos="fade-up">
                  From Principal Desk
                </p>
               {ReaadMore(principal)}

                {/* <p class='fs-5 my-3' data-aos="fade-up">As a new leader of Shristi English Medium School, Anand, Gujarat, I warmly welcome all of you to the website of our school and take pride in introducing you to the ethos, the conscientious drive and the inherent vision behind the school. SEMS has created a legacy of nurturing minds to dream the impossible. We are committed to empower them with the required skills, knowledge, capability, and the capacity to be truly successful, to become a good human being as well as a responsible global citizen.</p>
                            <div class='p-3 mt-4' style={{background:'#215395'}} data-aos="zoom-in">
                                <p class='text-white fs-5'>"Learning gives creativity, Creativity leads to thinking, Thinking provides knowledge, and Knowledge makes you GREAT." APJ Abdul Kalam.</p>
                            </div> */}
              </div>
            </div>
            <div class="col-lg-5 col-12 p-3 d-flex justify-content-end">
              <div
                style={{ maxWidth: "350px", height: "350px" }}
                data-aos="zoom-in"
              >
                <div>
                  <img
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "cover",
                      borderRadius: "20px",
                    }}
                    src={require("../images/other/principleparulrayappan.jpg")}
                    alt=""
                  />
                </div>
                <div
                  class="text-end d-flex rounded-5"
                  style={{
                    background: "#215395",
                    color: "white",
                    position: "relative",
                    top: "-30px",
                  }}
                >
                  <div class="text-start p-3">
                    <p class="fw-bold fs-5">Ms. Parul Rayappan</p>
                    <p class="fs-5">Principal (B.Ed., B.P.Ed.) </p>
                  </div>
                  {/* <div class='d-grid gap-1 rounded-5  p-3 mx-4 text-white' style={{background:'linear-gradient(180deg, #FDC830 0%, #F37335 100%)',marginTop:'-100px',height:'175px'}}>
                                    <i style={{cursor:'pointer'}}><AiOutlineInstagram/></i>
                                    <i style={{cursor:'pointer'}}><GrLinkedinOption/></i>
                                    <i style={{cursor:'pointer'}}><GrFacebookOption/></i>
                                    <i style={{cursor:'pointer'}}><BiPlusMedical/></i>  
                                </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div class='m-auto text-start' style={{padding:'20px 30px'}}>
                    <p data-aos="fade-up" class='fs-5'>Today, the role of a school is not only to pursue academic excellence but also to motivate and empower its students to be lifelong learners, critical thinkers, and productive members of an ever-changing global society. This can only be possible in a holistic, student-centric environment. SEMS strongly believes in activity based learning for grade KG to VIII std. where students show their keen interest and learn with great pleasure. For IX to XII, we go for application based teaching which is highly required for this generation to crack NEET/JEE or any competitive exam with flying colours.
                        During this pandemic time, SEMS has earned all the support and cooperation from each and every parent, guardian, student, faculty member at every step and I look forward to the same collaboration and support so that we embrace all the challenges with confidence, steadfastness and fortitude.
                        Stay well! Stay positive! Keep smiling!</p>
                </div> */}
          <br />
          <br />
        </div>
      </div>
      {facultyData.length > 0 && <div style={{ background: "#215395" }}>
        <br />
        <br />
        <div>
          <p class="display-3 fw-bold text-white " data-aos="fade-up">
            Our Faculty
          </p>
          {/* <p class='fs-5 text-white m-auto p-3' data-aos="fade-up" style={{maxWidth:'600px'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore e</p> */}
          {/* <div class='col-10 m-auto mt-5' >
                    <div style={{display: 'flex', justifyContent: 'space-between',overflowX: 'auto',width:'100%', borderBottom:'0.5px solid #5289BF'}}> 
                        <button class='infraBtn text-nowrap' style={category == "Category1" ? {color:'white', borderBottom:'5px solid #FFCC29', border:'none'}:{color:'#5289BF', border:'none',}} onClick={()=> setCategory("Category1")}>Category 1</button>
                        <button class='infraBtn text-nowrap' style={category == "Category2" ? {color:'white', borderBottom:'5px solid #FFCC29', border:'none'}:{color:'#5289BF', border:'none',}} onClick={()=> setCategory("Category2")}>Category 2</button>
                        <button class='infraBtn text-nowrap' style={category == "Category3" ? {color:'white', borderBottom:'5px solid #FFCC29', border:'none'}:{color:'#5289BF', border:'none',}} onClick={()=> setCategory("Category3")}>Category 3</button>
                        <button class='infraBtn text-nowrap' style={category == "Category4" ? {color:'white', borderBottom:'5px solid #FFCC29', border:'none'}:{color:'#5289BF', border:'none',}} onClick={()=> setCategory("Category4")}>Category 4</button>
                        <button class='infraBtn text-nowrap' style={category == "Category5" ? {color:'white', borderBottom:'5px solid #FFCC29', border:'none'}:{color:'#5289BF', border:'none',}} onClick={()=> setCategory("Category5")}>Category 5</button> 
                    </div>
                </div> */}
        </div>

        <br />
        <div
          class="col-10 m-auto"
          data-aos="zoom-in-up"
          style={{ overflowX: "auto" }}
        >
          {table(facultyData)}
        </div>
        <br />
      </div>}
    </div>
  );
};
